import { isValidURL } from "src/utils/stringUtils";
import { UrlValueType } from "src/utils/url";

type UrlValueProps = {
  value: UrlValueType;
  dataLoc?: string;
};

export const UrlValue: React.FC<UrlValueProps> = ({ value, dataLoc }) => {
  if (!value.url) return null;

  if (!isValidURL(value.url)) {
    return (
      <span className="truncate" data-loc={dataLoc}>
        {value.url}
      </span>
    );
  }

  const href = value.url.startsWith("http")
    ? value.url
    : `https://${value.url}`;
  const label = value.name ?? value.url;

  return (
    <div className="overflow-hidden" data-loc={dataLoc}>
      <a
        className="truncate underline hover:text-indigo-500"
        href={href}
        rel="noreferrer noopener"
        target="_blank"
      >
        {label}
      </a>
    </div>
  );
};
